import Cplx from "@/page/Cplx";
import Mjgl from "@/page/Mjgl";
import Zbcp from "@/page/Zbcp";
import Yys from "@/page/Yys";
import Md from "@/page/Md";
import Sgal from "@/page/Sgal";
import Js from "@/page/Js";
import Banner from "@/page/Banner";
import Bjgl from "@/page/Bjgl";
import Carmodel from "@/page/CarModel";
import Cpjm from "@/page/Cpjm";
import CarBrand from "@/page/CarBrand";
import Our from "@/page/Our";
import Xw from "@/page/Xw";

/* {url:'/cpyx',icon:"el-icon-shopping-bag-2",text:'产品原型管理'},
{url:'/zbcp',icon:"el-icon-tickets",text:'质保产品管理'},
{url:'/zbkh',icon:"el-icon-user",text:'质保客户管理'},
{url:'/yys',icon:"el-icon-menu",text:'经销商管理'},
{url:'/md',icon:"el-icon-place",text:'门店管理'},
{url:'/js',icon:"el-icon-medal",text:'技师管理'},
{url:'/img',icon:"el-icon-picture-outline",text:'图片案例管理'},
{url:'/video',icon:"el-icon-video-camera",text:'视频案例管理'},
{url:'/banner',icon:"el-icon-picture-outline",text:'Banner管理'},
{url:'/ppsp',icon:"el-icon-video-camera",text:'品牌视频管理'},
{url:'/qx',icon:"el-icon-setting",text:'权限管理'}, */

var allRoute = [
  {
    path: "/cplx",
    name: "Cplx",
    component: Cplx,
    text: "产品类型管理",
    icon: "el-icon-shopping-bag-2"
  },
  {
    path: "/mjgl",
    name: "Mjgl",
    component: Mjgl,
    text: "质保产品管理",
    icon: "el-icon-shopping-bag-2"
  },
  {
    path: "/zbcp",
    name: "Zbcp",
    component: Zbcp,
    text: "质保客户管理",
    icon: "el-icon-tickets"
  },
  {
    path: "/yys",
    name: "Yys",
    component: Yys,
    text: "经销商管理",
    icon: "el-icon-menu"
  },

  {
    path: "/md",
    name: "Md",
    component: Md,
    text: "门店管理",
    icon: "el-icon-place"
  },
  {
    path: "/js",
    name: "Js",
    component: Js,
    text: "技师管理",
    icon: "el-icon-medal"
  },
  {
    path: "/Carmodel",
    name: "Carmodel",
    component: Carmodel,
    text: "车辆型号管理",
    icon: "el-icon-truck"
  },
  {
    path: "/CarBrand",
    name: "CarBrand",
    component: CarBrand,
    text: "车辆品牌管理",
    icon: "el-icon-truck"
  },

  {
    path: "/bjgl",
    name: "Bjgl",
    component: Bjgl,
    text: "报价管理",
    icon: "el-icon-goods"
  },
  {
    path: "/cpjm",
    name: "Cpjm",
    component: Cpjm,
    text: "产品系列管理",
    icon: "el-icon-goods"
  },
  {
    path: "/banner",
    name: "Banner",
    component: Banner,
    text: "Banner管理",
    icon: "el-icon-picture-outline"
  },
  {
    path: "/sgal",
    name: "Sgal",
    component: Sgal,
    text: "施工案例",
    icon: "el-icon-place"
  },
  {
    path: "/xw",
    name: "Xw",
    component: Xw,
    text: "新闻",
    icon: "el-icon-place"
  },
  {
    path: "/our",
    name: "Our",
    component: Our,
    text: "关于我们",
    icon: "el-icon-user"
  }
];
export default allRoute;



// WEBPACK FOOTER //
// ./src/router/route.js